/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Raffle_Draw_OneInputs */



/**
* | output |
* | --- |
* | "Draw {count} winner" |
*
* @param {Raffle_Draw_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_draw_one = /** @type {((inputs: Raffle_Draw_OneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Draw_OneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tirer ${i?.count} gagnant`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Sortear ${i?.count} ganador`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Sortear ${i?.count} vencedor`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Estrai ${i?.count} vincitore`)
	return /** @type {LocalizedString} */ (`Draw ${i?.count} winner`)
});